import { registerAfterCollectionUpdate, type AfterCollectionUpdateContext } from "./postUpdate";
import { refreshCollectionLoadMore } from "./loadMore";
import { initCollectionFilters, refreshResultCounts } from "../collectionFilters";
import { handleNavAfterCollectionUpdate, initCollectionNavRouter } from "../ekCollectionNav";

declare global {
  interface Window {
    BannerSlider?: {
      init: (container?: ParentNode) => void;
    };
  }
}

export const wireCollectionPage = () => {
  registerAfterCollectionUpdate(async (ctx: AfterCollectionUpdateContext) => {
    initCollectionFilters(ctx.scope);
    await refreshResultCounts();
    window.ProductCardSwatches?.initAll(ctx.scope);
    window.BannerSlider?.init(ctx.scope);
    refreshCollectionLoadMore();
  });

  registerAfterCollectionUpdate((ctx: AfterCollectionUpdateContext) => {
    if (ctx.mode !== "nav") return;
    handleNavAfterCollectionUpdate({
      preserveSubcollectionNav: ctx.preserveSubcollectionNav,
      headerSection: ctx.headerSection,
      activeHandle: ctx.activeHandle,
      navParent: ctx.navParent,
    });
  });

  initCollectionNavRouter();
};
